import { Navigate } from 'react-router-dom';
// routes
import { PATH_AUTH } from '../routes/paths';
// components
import LoadingScreen from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------
// new
type GuestGuardProps = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();
  console.log("user",user);
  console.log('isAuthenticated', isAuthenticated);
  if (isAuthenticated) {
    if (user?.role === 'Broker') {
      return <Navigate to={PATH_AUTH.company.list} />;
    } else if (user?.role === 'Underwriter') {
      return <Navigate to={PATH_AUTH.company.list} />;
    } else {
      return <Navigate to={PATH_AUTH.root} />;
    }
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <> {children} </>;
}
